// extracted by mini-css-extract-plugin
export default {"logo":"WattAttackLogo_logo__m2qKV"};